import styled from '@emotion/styled'
import { Layout } from 'antd'

export const ContentWrapper = styled(Layout.Content)`
  margin: 0;
  padding: 15px;
  max-height: calc(100vh - 85px);
  overflow-y: auto;
`
